import React, { useEffect, useRef, useState } from "react";

import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";

import styles from "../../scss/common/ProductCard.module.scss";
import thanku from "../../assets/images/thanku.svg";
import { downloadPDF } from "../../common/utils/Functions";
import AppButton from "../../common/theme/Button";
import useFetch from "../../customHook/useFetch";

const RECEIPT_POLL_INTERVAL_MS = 2000;
const RECEIPT_POLL_MAX_MS = 45000;

const ThankYouCart = () => {
  const navigate = useNavigate();

  const location = useLocation();
  const [id, setId] = useState("");
  const [orderId, setOrderId] = useState("");
  const [email, setEmail] = useState("");
  const [receipt, setReceipt] = useState("");
  const [loader, setLoader] = useState(false);
  const [storeName, setStoreName] = useState("");
  const [receiptPreparing, setReceiptPreparing] = useState(false);
  const pollStartedRef = useRef(false);
  const [
    editBundleQuery,
    {
      response: editBundleResponse,
      loading: editBundleLoading,
      error: editBundleError,
    },
  ] = useFetch(`/is_order_place/${id}`, {
    method: "put",
  });
  useEffect(() => {
    if (location?.state) {
      setId(location?.state?.orderResponce?.id);
      setOrderId(location?.state?.orderResponce?.orderId);
      setEmail(location?.state?.orderResponce?.email);
      setReceipt(location?.state?.orderResponce?.receipt || "");
      setStoreName(
        `${location?.state?.orderResponce?.storeName ? location?.state?.orderResponce?.storeName?.replaceAll(" ", "-") : `Order-Detail`}-${
          location?.state?.orderResponce?.orderId
        }.pdf`
      );
    }
  }, [location]);

  useEffect(() => {
    if (id) {
      editBundleQuery();
    }
  }, [id]);

  useEffect(() => {
    if (editBundleResponse) {
      console.log(editBundleResponse, "editBundleResponse");
    }
  }, [editBundleResponse]);

  // Poll for async receipt PDF when create-order returned an empty receipt
  useEffect(() => {
    if (!id || receipt || pollStartedRef.current) {
      return;
    }
    pollStartedRef.current = true;
    setReceiptPreparing(true);

    const startedAt = Date.now();
    let cancelled = false;
    let timeoutId: ReturnType<typeof setTimeout> | null = null;

    const poll = async () => {
      if (cancelled) return;
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_BASE_URL}/order-receipt/${id}`
        );
        const receiptUrl = response?.data?.data?.receipt || "";
        if (receiptUrl) {
          if (!cancelled) {
            setReceipt(receiptUrl);
            setReceiptPreparing(false);
          }
          return;
        }
      } catch (err) {
        console.error("Error polling order receipt:", err);
      }

      if (Date.now() - startedAt >= RECEIPT_POLL_MAX_MS) {
        if (!cancelled) {
          setReceiptPreparing(false);
        }
        return;
      }

      timeoutId = setTimeout(poll, RECEIPT_POLL_INTERVAL_MS);
    };

    poll();

    return () => {
      cancelled = true;
      if (timeoutId) clearTimeout(timeoutId);
    };
  }, [id, receipt]);

  return (
    <>
      <div
        style={{ textAlign: "center", marginTop: "50px", marginBottom: "50px" }}
      >
        <img
          loading="lazy"
          src={thanku}
          className={styles.emptyShoppingImg}
          alt=""
        />
        <div className={styles.emptyShopping}>
          <h2 style={{ marginTop: "25px" }}>Thank You</h2>
          <p style={{ margin: "15px auto" }}>
            Your order <strong>#{orderId}</strong> has been placed.
          </p>

          <p style={{ marginBottom: "35px" }}>
            A copy of your receipt has been sent to <strong>{email}</strong>
          </p>
          {receiptPreparing && !receipt ? (
            <p style={{ marginBottom: "15px", color: "#666" }}>
              Receipt preparing…
            </p>
          ) : null}
          <div style={{ marginTop: "10px" }}>
            <AppButton
              onClick={() => {
                navigate("/");
              }}
              style={{ marginRight: "10px" }}
            >
              Return to Store
            </AppButton>
            <AppButton
              onClick={async () => {
                if (!receipt) return;
                setLoader(true);
                await downloadPDF(receipt, storeName);
                setLoader(false);
              }}
              variant="outlined"
              disabled={loader || !receipt}
              style={{ color: "#0e2b3a" }}
            >
              Print Receipt
            </AppButton>
          </div>
        </div>
      </div>
    </>
  );
};

export default ThankYouCart;
